import { Component, ViewChild, Input} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AssetProductService } from '../../services/asset-product-service';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'asset-product-category-lov',
    templateUrl: './asset-product-category-lov.component.html',
    styleUrls: ['./asset-product-category-lov.component.scss']
})


export class AssetProductCategoryLovComponent extends GenericLovComponent   {

    @Input() code         : string; 

    assetProductCategories          : AssetProductCategory[] = [];

    columns = [
        {  prop: 'assetProductCategoryCode', name: 'Code'},
        {  prop: 'name', name: 'Name'               }
    ]

    constructor(
        public dialogRef: MatDialogRef<AssetProductCategoryLovComponent>,
        private assetProductService : AssetProductService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected location          : Location) {
          super();
      }
      

    //------------------------------------------------------------------------------------------
    loadData() {
        this.assetProductService.assetProductCategoriesGet(this.code).then(result => {
            this.assetProductCategories = result;
        })
    }
    //------------------------------------------------------------------------------------------

    //------------------------------------------------------------------------------------------
    closeModal(assetProductCategory : AssetProductCategory){
        this.dialogRef.close(assetProductCategory);
    }
    //------------------------------------------------------------------------------------------
        
}
